import { render, staticRenderFns } from "./CommunityBtn.vue?vue&type=template&id=32d05024&scoped=true"
import script from "./CommunityBtn.vue?vue&type=script&lang=js"
export * from "./CommunityBtn.vue?vue&type=script&lang=js"
import style0 from "./CommunityBtn.vue?vue&type=style&index=0&id=32d05024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d05024",
  null
  
)

export default component.exports